"use client"

import { useEffect, useState } from "react"
import { Modal, Button, Box, Grid, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import API, { URL_PATH } from "../services/API"
import Cookies from "js-cookie"

import Text from "./Text"
import IsolatedStatusModal from "./StatusModal"
import Toast from "./Toast"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#02111B",
  border: "2px solid #FFC857",
  boxShadow: 24,
  p: 4,
  color: "white",
  borderRadius: "10px",
}

const SwitchTable = ({ onCancel, onConfirm, isOpen, orderId = 0, method = "order", handleSuccess }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({
      title: "",
      text: "",
      icon: "",
      type:""
    });
  const [isLoading, setIsLoading] = useState(false)
  const [id, setOrder_id] = useState("")
  const [token_no, setToken_no] = useState(0)
  const [isTableAvailable, setIsTableAvailable] = useState(false)
  const [hotelFloors, setHotelFloors] = useState([])
  const [selectedTables, setSelectedTables] = useState([])
  const [maxCapacity, setMaxCapacity] = useState(0)
  const [curentTableCapacity, setCurentTableCapacity] = useState(0)
  const [type, setType] = useState("")
  const [waiting_table, setWaiting_table] = useState({})
  const [hotel, setHotel] = useState({})
  const [user, setUser] = useState({})

  useEffect(() => {
    setOrder_id(orderId)
  }, [])

  useEffect(() => {
    if (id) {
      getData()
    }
  }, [id])

  const getAvailableTables = async () => {
    const { status, message, isTableAvailable, hotel, hotelFloors } = await API(
      this,
      "get",
      URL_PATH.availabelTablesForDigitalToken(Cookies.get("selectedHotelId")),
    )
    console.log(JSON.stringify({ isTableAvailable, hotel, hotelFloors }))

    if (status == "error") {
      setShowModal(true); // Assuming you have a state variable for showing the modal
      setModalData({
        title: "error",
        text: message,
        type: "error",
      });
      return
    }

    hotelFloors.forEach((floor) => {
      floor.isExpanded = true
    })

    setIsTableAvailable(isTableAvailable);
    setHotelFloors(hotelFloors);
    setHotel(hotel);
  };
   const bookingDetails = async () => {
    
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.bookingDetails(id)
    );

    console.log(status, message, data)

      if (status == "error") {
        setShowModal(true); // Assuming you have a state variable for showing the modal
        setModalData({
          title: "error",
          text: message,
          type: "error",
        });
        return    }

    const { no_of_peoples, user } = data


    setType("booking");
    setMaxCapacity(no_of_peoples);
    setUser(user);
  };

  // const bookingDetails = async () => {
    
  //   const { status, message, data } = await API(
  //     this,
  //     "get",
  //     URL_PATH.bookingDetails(id)
  //   );

  //   if (status == "error") {
  //     return window.Alert(message);
  //   }

  //   const { no_of_peoples, user } = data;


  //   setType("booking");
  //   setMaxCapacity(no_of_peoples);
  //   setUser(user);
  // };

  const orderDetails = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.orderDetails(id))

    if (status == "error") {
      setShowModal(true); // Assuming you have a state variable for showing the modal
      setModalData({
        title: "error",
        text: message,
        type: "error",
      });
      return    }

    const { type } = data

    var capacity = 0
    var token_no = 0

    if (type == "normal") {
      const { table_capacity } = data
      capacity = table_capacity
    }
    if (type == "joined") {
      const { capacity: table_capacity } = data
      capacity = table_capacity
    }
    if (type == "waiting") {
      const { number_of_people: table_capacity, id } = data
      capacity = table_capacity
      token_no = id
    }

    setType(type)
    setMaxCapacity(capacity)
    setToken_no(token_no)
  }

  const getData = async () => {
    getAvailableTables()
    if (method == "order") return orderDetails()
    if (method == "booking") return bookingDetails()
  }

  const handleCancel = () => {
    onCancel()
  }

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      // await apiCall();
      onConfirm()
    } catch (error) {
      console.error("API call failed:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const onTablePress = (floor, table) => {
    const { id: table_id } = table
    const { id: floor_id } = floor

    const index = selectedTables.findIndex((item) => item.table_id == table_id && item.floor_id == floor_id)

    var curentTableCapacity_ = curentTableCapacity

    if (index == -1) {
      selectedTables.push({ table_id, floor_id })
      curentTableCapacity_ = curentTableCapacity + table.table_capacity
    } else {
      selectedTables.splice(index, 1)
      curentTableCapacity_ = curentTableCapacity - table.table_capacity
    }

    setSelectedTables([...selectedTables])
    setCurentTableCapacity(curentTableCapacity_)
  }

  const onSubmit = async () => {
    if (selectedTables.length == 0) {
      setShowModal(true); // Assuming you have a state variable for showing the modal
      setModalData({
        title: "error",
        text: "Please select the table",
        type: "error",
      });
      return

    }

    const fd = {
      order_id: id,
      table_ids: selectedTables.map((item) => item.table_id),
      type,
      method,
      user: user ?? {},
    }

    const url = method == "order" ? URL_PATH.assignTable : URL_PATH.assignTableForBooking

    const { status, message, data } = await API(this, "post", url, fd)

    if (status == "error") {
setShowModal(true); // Assuming you have a state variable for showing the modal
      setModalData({
        title: "Error",
        text: message,
        type: "error",
      });    }


      setModalData({
        title: "Success",
        text: message,
        type: "success",
      });
      console.log("Modaldata",modalData)
      setShowModal(true); // Assuming you have a state variable for showing the modal
    handleSuccess()
  }

  return (
    <>
    <Modal open={isOpen} onClose={handleCancel} fullWidth size="large">
      <Box sx={style}>
        {/* Close icon */}
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* details */}
        <Box sx={{ margin: "20px 0px" }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Text bold>{method == "booking" ? "Booking ID" : type == "waiting" ? "Token no" : "Order ID"}</Text>
            </Grid>
            <Grid item xs={6}>
              <Text>{type == "waiting" ? token_no : id}</Text>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: "1px" }}>
            <Grid item xs={6}>
              <Text>No Of Person </Text>
            </Grid>
            <Grid item xs={6}>
              <Text>{maxCapacity}</Text>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: "1px" }}>
            <Grid item xs={6}>
              <Text bold color={curentTableCapacity > maxCapacity ? "#BB0A21" : "white"}>
                Selected Capacity{" "}
              </Text>
            </Grid>
            <Grid item xs={6}>
              <Text bold color={curentTableCapacity > maxCapacity ? "#BB0A21" : "white"}>
                {curentTableCapacity}
              </Text>
            </Grid>
          </Grid>
        </Box>

        {hotelFloors.map((floor) => {
          if (floor.tables.length == 0) return null
          return (
            <Box
              key={floor.id}
              sx={{
                border: "1px solid #FFC857",
                backgroundColor: "#02111B",
                padding: "15px",
                marginBottom: "15px",
                borderRadius: "8px",
              }}
            >
              <Text regular h7 sx={{ color: "#FFC857" }}>
                {floor.floor_no}
              </Text>
              <Grid
                container
                spacing={2}
                sx={{
                 
                  padding: "10px",
                  borderRadius: "5px",
                 
                }}
              >
                {floor.tables?.map((table) => {
                  const isSelected =
                    selectedTables.findIndex((item) => item.table_id == table.id && item.floor_id == floor.id) !== -1
                  return (
                    <Grid
                      item
                      xs={6}
                      sm={4}
                      md={3}
                      key={table.id}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        cursor: "pointer",
                        margin: "8px", // Add margin here

                        "&:hover": {
                          opacity: 0.8,
                        },
                      }}
                      onClick={() => onTablePress(floor, table)}
                    >
                      <Box
                        sx={{
                          backgroundColor: isSelected ? "#00A651" : "#02111B",
                          padding: "8px 12px",
                          borderTopLeftRadius: "5px",
                          borderBottomLeftRadius: "5px",
                          borderStyle: "solid",
                          borderColor: "#FFC857",
                          borderWidth: "1px",
                          borderRightWidth: "0",
                        }}
                      >
                        <Text color="white">{table.table_no}</Text>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: isSelected ? "#FFC857" : "#FFC857",
                          padding: "8px 12px",
                          borderTopRightRadius: "5px",
                          borderBottomRightRadius: "5px",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          color: isSelected ? "black" : "black",
                        }}
                      >
                        <i className="fa fa-user">&nbsp;</i>
                        <Text color={isSelected ? "black" : "black"}>{table.table_capacity}</Text>
                      </Box>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
          )
        })}

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
          <Button
            onClick={handleCancel}
            sx={{
              backgroundColor: "#BB0A21",
              color: "white",
              "&:hover": {
                backgroundColor: "#8B061A",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              backgroundColor: "#00A651",
              color: "white",
              "&:hover": {
                backgroundColor: "#008C44",
              },
            }}
          >
            {method == "booking" ? "Assign Table" : type == "waiting" ? "Assign table" : "Change table"}
          </Button>
        </Box>
      </Box>
    </Modal>
    <IsolatedStatusModal
              title={modalData.title}
              isOpen={showModal}
              type={modalData.type}
              message={modalData.text}
              icon={modalData.icon}
              buttonText={"Okay"}

              onClose={() => setShowModal(false)}
            />
    </>
    
  )
}

export default SwitchTable

